import { render, staticRenderFns } from "./zzjg.vue?vue&type=template&id=26587c4f&scoped=true&"
import script from "./zzjg.vue?vue&type=script&lang=js&"
export * from "./zzjg.vue?vue&type=script&lang=js&"
import style0 from "./zzjg.vue?vue&type=style&index=0&id=26587c4f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26587c4f",
  null
  
)

export default component.exports